import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.lineItemsSection.LineItemsTableRow', {
    lineActionCloneText: 'Clone a line',
    lineActionRemoveText: 'Remove a line',
    lineActionCloneTitle: 'Clone a line',
    lineActionRemoveTitle: 'Remove a line',
});
